import React, { useEffect, useState } from 'react';
import userDirectoryIcon from 'assets/images/icons/user-directory-2.svg';
import plusIcon from 'assets/images/icons/plus.svg';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import TableComponent from 'components/table-component-new/Table';
import TablePagination from 'components/table-component-new/TablePagination';
import { guestUserTableFields } from '../utils';
import { CallAPI } from 'actions/General';
import GuestUsersListHeader from './GuestUsersListHeader';
import GuestUserEditModal from './GuestUserEditModal';
import FormButton from 'components/form-components/FormButton';
import toast from 'react-hot-toast';

const GuestUsersList = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [displayEntries, setDisplayEntries] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [allUsers, setUsers] = useState([]);
  const [filter, setFilter] = useState({});
  const [tableActionState, setTableActionState] = useState(null);

  const handleDebouncedFilter = (name, value) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const actionsCallBack = async (action, data) => {
    if (action === 'edit') {
      setTableActionState({
        type: 'edit',
        data: data.ids,
      });
    } else if (action === 'delete') {
      const payload = { ids: data.ids };
      const result = await CallAPI('DELETE_BULK_DIRECTORY_USERS', payload);
      if (result.status) {
        toast.success("User's deleted successfully");
        fetchUsersList();
      }
    }
  };

  const fetchUsersList = async (page = currentPage, limit = displayEntries) => {
    setSelectedRows([]);
    setTableActionState(null);

    const payload = { page, limit };
    if (filter.search) payload.searchText = filter.search;

    const result = await CallAPI('GET_ALL_DIRECTORY_USERS', payload, null, setLoading);
    if (result.status) {
      let allUsers = [];
      result.data.list.map((singleUser) => {
        allUsers.push({
          id: singleUser._id,
          firstName: singleUser.firstName,
          lastName: singleUser.lastName,
          countryCode: singleUser.countryCode || '',
          mobileNumber: singleUser.mobileNumber || '',
          email: singleUser.email || '',
        });
      });
      setUsers(allUsers);
      if (result.data.count) setTotalRecords(result.data.count);
    }
  };

  const onRowsSelection = (name, value) => {
    let tempSelection = [];

    if (name === 'all') {
      if (value) tempSelection = cloneDeep(allUsers);
      else tempSelection = [];
    } else {
      tempSelection = cloneDeep(selectedRows);
      if (value) {
        const tempSelectedRow = allUsers.find((t) => t.id === name);
        if (tempSelectedRow) tempSelection.push(tempSelectedRow);
      } else tempSelection = tempSelection.filter((s) => s.id !== name);
    }
    setSelectedRows(tempSelection);
  };

  useEffect(() => {
    fetchUsersList();
  }, [filter]);

  return (
    <div className='p-3'>
      <div className='d-flex gap-1 flex-column'>
        <label className='theme-size-2 theme-text-black-1'>{t('text_users')}</label>
        <label>{t('text_guest_user_description')}</label>
      </div>
      <GuestUsersListHeader
        handleDebouncedFilter={handleDebouncedFilter}
        selectedRows={selectedRows}
        actionsCallBack={actionsCallBack}
        openAddUserModal={() =>
          setTableActionState({
            type: 'add',
          })
        }
      />

      <TableComponent
        header={guestUserTableFields}
        data={allUsers}
        props={{
          actionsType: 'guestUser',
          actionsCallBack: actionsCallBack,
        }}
        totalRecords={totalRecords}
        loader={loading}
        isFieldSelectionEnabled={false}
        isActionsEnabled={true}
        isSelectionEnabled={true}
        selectionKey={'id'}
        onSelection={onRowsSelection}
        selectedRows={selectedRows}
        headerCellBorder='vertical'
        bodyCellBorder='both'
        noDataComponent={
          <div className='w-100 d-flex flex-column gap-2 justify-content-center align-items-center py-3'>
            <img className='svg-grey' src={userDirectoryIcon} />
            <span className='theme-text-black-1 theme-font-inter-semi-bold theme-size-1_2'>
              {t('text_no_guest_users')}
            </span>
            <span>{t('text_currently_no_user_added_in_guests')}</span>
            <FormButton
              text={'button_add_user'}
              variant='green-1'
              iconClasses='svg-white'
              onClick={() =>
                setTableActionState({
                  type: 'add',
                })
              }
              icon={plusIcon}
            />
          </div>
        }
      />

      {totalRecords > 0 && (
        <TablePagination
          totalRecords={totalRecords}
          currentPageRecords={allUsers.length}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          displayEntries={displayEntries}
          setDisplayEntries={setDisplayEntries}
          listingFunction={fetchUsersList}
        />
      )}

      {(tableActionState?.type === 'add' || tableActionState?.type === 'edit') && (
        <GuestUserEditModal
          handleClose={() => setTableActionState(null)}
          refreshList={fetchUsersList}
          editMode={!!tableActionState.data}
          data={tableActionState.data}
        />
      )}
    </div>
  );
};

export default GuestUsersList;
